import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, apiPost, operationsClient } from '@/lib/api';
import { invoiceKeys, progressPaymentKeys } from '@/lib/queryKeys';
import { progressPaymentEndpoints } from '@/lib/api/endpoints';
import type {
  ProgressPaymentInvoiceResult,
  ProgressPaymentListResponse,
} from '@/types/progressPayment';

export function useJobProgressPayments(jobId: string, options: { enabled?: boolean } = {}) {
  return useApiQuery<ProgressPaymentListResponse>({
    queryKey: progressPaymentKeys.byJob(jobId),
    queryFn: () =>
      apiGet<ProgressPaymentListResponse>(
        operationsClient,
        progressPaymentEndpoints.listByJob(jobId),
      ),
    enabled: Boolean(jobId) && (options.enabled ?? true),
  });
}

export function useInvoiceProgressPayment(jobId?: string) {
  const queryClient = useQueryClient();
  return useApiMutation<ProgressPaymentInvoiceResult, string>({
    mutationFn: (id) =>
      apiPost<ProgressPaymentInvoiceResult, Record<string, never>>(
        operationsClient,
        progressPaymentEndpoints.invoice(id),
        {},
      ),
    onSuccess: () => {
      if (jobId) {
        void queryClient.invalidateQueries({ queryKey: progressPaymentKeys.byJob(jobId) });
        void queryClient.invalidateQueries({ queryKey: invoiceKeys.byJob(jobId) });
      }
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.all() });
      toast.success('Milestone invoice created');
    },
  });
}
